import React, { useState } from 'react'
import moment, { Moment } from 'moment'
import DatePicker from 'react-datepicker'
import DateService from 'live/services/date'
import LiveSelect from 'live/components/forms/ui/select'
import CustomDateInput from 'live/components/forms/ui/custom-react-datepicker-input'
import styled from 'styled-components'

function displayValue(value: string | number | undefined) {
    return value != undefined ? value : ''
}

function Input({ type, options, readOnly, onChange, onBlur, value, ...props }: any) {
    const [prevValue, setPrevValue] = useState<any>('')

    switch (type) {
        case "int":
            return (
                <CustomInput
                    {...props}
                    readOnly={readOnly}
                    value={displayValue(value)}
                    type="number"
                    onKeyDown={e => {
                        if (e.keyCode > 31 && (e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
                            e.preventDefault()
                        }
                    }}
                    onChange={e => {
                        if (onChange) {
                            onChange(e.target.value)
                        }
                    }}
                    onFocus={e => setPrevValue(e.target.value)}
                    onBlur={({ target }) => {
                        if (prevValue === target.value) return

                        const value = isNaN(parseInt(target.value)) ? target.value : parseInt(target.value)

                        if (onBlur) {
                            onBlur(value, prevValue)
                        }
                    }
                    }
                />
            )
        case "float":
            return (
                <CustomInput
                    {...props}
                    readOnly={readOnly}
                    value={displayValue(value)}
                    type="number"
                    onChange={e => {
                        if (onChange) {
                            onChange(e.target.value)
                        }
                    }}
                    onFocus={e => setPrevValue(e.target.value)}
                    onBlur={({ target }) => {
                        if (prevValue === target.value) return

                        const value = isNaN(parseFloat(target.value)) ? target.value : parseFloat(target.value)

                        if (onBlur) {
                            onBlur(value, prevValue)
                        }
                    }
                    }
                />
            )
        case "string":
            return (
                <CustomInput
                    {...props}
                    readOnly={readOnly}
                    value={displayValue(value)}
                    type="text"
                    onChange={e => {
                        if (onChange) {
                            onChange(e.target.value)
                        }
                    }}
                    onFocus={e => setPrevValue(e.target.value)}
                    onBlur={({ target }) => {
                        if (prevValue === target.value) return

                        if (onBlur) {
                            onBlur(target.value, prevValue)
                        }
                    }
                    }
                />
            )
        case "textarea":
            return (
                <textarea
                    {...props}
                    readOnly={readOnly}
                    value={displayValue(value)}
                    onChange={e => {
                        if (onChange) {
                            onChange(e.target.value)
                        }
                    }}
                    onFocus={e => setPrevValue(e.target.value)}
                    onBlur={({ target }) => {
                        if (prevValue === target.value) return

                        if (onBlur) {
                            onBlur(target.value, prevValue)
                        }
                    }
                    }
                />
            )
        case 'select':
            return (
                <LiveSelect
                    {...props}
                    readOnly={readOnly}
                    disabled={readOnly}
                    value={value}
                    options={options}
                    onChange={(value: any) => {

                        setPrevValue(value)

                        if (onBlur) {
                            onBlur(value, prevValue)
                        }
                        if (onChange) {
                            onChange(value)
                        }
                    }}
                />
            )
        case 'date':
            return (
                <DatePicker
                    {...props}
                    readOnly={readOnly}
                    selected={moment(value) || null}
                    onChange={async (value: Date) => {
                        const dateString = moment(value)
                            .utc()
                            .toISOString()

                        setPrevValue(dateString)

                        if (onBlur) {
                            onBlur(dateString, prevValue)
                        }

                        if (onChange) {
                            onChange(dateString)
                        }

                    }}
                    customInput={<CustomDateInput />}
                    dateFormat={DateService.getDateFormat()}
                    placeholderText={DateService.getDateFormat().toLowerCase()}
                />
            )
        default:
            return (
                <CustomInput
                    {...props}
                />
            )
    }
}

export default React.memo(Input)

const CustomInput = styled.input`
    /* Firefox */
    -moz-appearance:textfield;
`